/* Pure checks behind the policy review flow (design eval F18), used by
   PolicyReviewParts and pages/Policies. */

export function typedMatches(expected: string, typed: string): boolean {
    return typed.trim() === expected.trim() && expected.trim() !== '';
}

export const SAMPLE_INPUT_PLACEHOLDER = `{
  "user": { "email": "alice@example.com", "roles": ["developer"], "groups": ["eng"] },
  "resource": { "id": "res-123", "type": "ssh" },
  "request": { "ip": "10.0.0.5", "action": "connect" }
}`;

/** null when empty or valid JSON; otherwise the parse error. */
export function sampleInputError(text: string): string | null {
    if (!text.trim()) return null;
    try {
        JSON.parse(text);
        return null;
    } catch (e) {
        return `Not valid JSON: ${e instanceof Error ? e.message : 'parse error'}`;
    }
}
